<div class="ty-page-container">
  <span nz-icon nzType="check-circle" nzTheme="outline"></span>
  @if (selectedRoute === 'generic-consultation') {
    <h2 class="title-generic">{{ 'steps.tyPage.titleGeneric' | translate }}</h2>
  }
  @if (selectedRoute !== 'generic-consultation') {
    <h2>{{ 'steps.tyPage.' + (isFromPayment ? isFromPayment.toLowerCase() : 'title') | translate }}</h2>
  }
  @if (selectedRoute !== 'generic-consultation' && selectedRoute !== 'televisit-generic-booking') {
    <p>{{ 'steps.tyPage.description' | translate }}</p>
  }
  @if (selectedRoute === 'televisit-generic-booking') {
    <p>{{ 'steps.tyPage.description_televisit_generic' | translate }}</p>
  }
  <ds-button text="{{ 'steps.tyPage.button' | translate }}" [width]="'small'" (click)="exit()"></ds-button>
</div>
